<template>
  <app-modal
    v-if="show"
    :maxWidth="maxWidth"
    :maxHeight="maxHeight"
    :isClickMaskClose="false"
    @close="hideModal"
  >
    <div class="object-templates__atributes">
      <h3 class="object-templates__atributes_title">
        {{ $t("object_templates_attributes_title", { title }) }}
      </h3>

      <div class="object-templates__atributes_item">
        <el-table
          v-loading="loading"
          :data="attributes"
          stripe
          style="width: 100%;"
        >
          <el-table-column
            prop="name"
            :label="$t('object_templates_table_name')"
          ></el-table-column>

          <el-table-column
            prop="attribute"
            :label="$t('object_templates_table_type')"
          >
            <template slot-scope="scope">
              {{ getAttributeName(scope.row.attribute) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="noTranslationRequired"
            :label="$t('attribute_templates_table_alone')"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.noTranslationRequired" type="success">
                {{ $t("attribute_templates_table_alone_yes") }}
              </el-tag>
              <el-tag v-else>
                {{ $t("attribute_templates_table_alone_no") }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="numberInOrder"
            width="150"
            :label="$t('object_templates_table_order')"
          >
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.numberInOrder"
              ></el-input-number>
            </template>
          </el-table-column>

          <el-table-column
            prop="required"
            width="100"
            align="center"
            :label="$t('object_templates_table_required')"
          >
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.required"></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column
            prop="used"
            width="250"
            :label="$t('object_templates_table_system')"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.used" multiple>
                <el-option
                  v-for="item in systems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="attributeId" width="70" align="center">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-plus"
                type="primary"
                :title="$t('object_templates_attributes_new_attr')"
                @click="save(scope.row.attributeId)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        class="object-templates__atributes_item object-templates__atributes_action"
      >
        <el-button @click="hideModal">
          {{ $t("object_templates_attributes_cancel") }}
        </el-button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { Attribute } from "@/mixins";

export default {
  name: "ObjectTemplatesAttributes",
  components: {
    AppModal: () =>
      import(
        /* webpackChunkName: "appModal" */ "@/components/library.blocks/AppModal.vue"
      )
  },
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    systems: Array,
    attributes: Array,
    loading: Boolean,
    attributeTypes: Array,
    references: Array
  },
  mixins: [Attribute],
  data() {
    return {};
  },
  computed: {
    disabledAction() {
      return true;
    }
  },
  methods: {
    hideModal() {
      this.$emit("close");
    },
    save(id) {
      this.$emit("add", id);
    }
  }
};
</script>

<style lang="scss">
.object-templates__atributes {
  .object-templates__atributes_title {
    text-align: left;
    padding: 5px 10px;
  }

  .object-templates__atributes_item {
    padding: 5px 10px;
  }

  .object-templates__atributes_action {
    text-align: right;
    padding-bottom: 10px;
  }
}
</style>
